/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FileCategory {
    SOURCE_DOCUMENT = 'SOURCE_DOCUMENT',
    REFERENCE = 'REFERENCE',
}
